import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  private apiUrl = environment.baseUrlApi;

  constructor(private http: HttpClient) {}

  // Recherche clients autocomplete (min 3 caractères)
  searchClients(query: string): Observable<any[]> {
    const params = new HttpParams().set('q', query);
    return this.http.get<any[]>(`${this.apiUrl}/payment/search-payment`, { params });
}

  // Envoyer le lien de paiement
  sendPaymentLink(data: {
    client_id: number;
    type: string;
    montant: number;
  }): Observable<any> {
    return this.http.post(`${this.apiUrl}/payment/send`, data);
  }

  getPaymentRequests(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/payment/requests`);
}
}